import { createValueAndHalfValue } from '../../createValueAndHalfValue';

const createPopoverTokens = () => {
  const spaces = createValueAndHalfValue({
    tiny: 6,
    small: 8,
    medium: 15,
    large: 15,
  });
  return {
    space: {
      ...spaces,
      arrow: {
        ...spaces,
      },
    },
    sizes: {
      tiny: '100px',
      small: '180px',
      medium: '400px',
      large: '600px',
      arrow: {
        ...spaces,
      },
    },
  };
};

export default createPopoverTokens;
